import { ButtonHTMLAttributes, forwardRef } from 'react';
import { VariantProps } from 'tailwind-variants';
import { Slot } from '@radix-ui/react-slot';
import { buttonVariants } from './styles';

export interface ButtonProps
  extends VariantProps<typeof buttonVariants>,
    ButtonHTMLAttributes<HTMLButtonElement> {
  asChild?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, className, variant, size, outline, asChild = false, ...props }, ref) => {
    const ComponentSlot = asChild ? Slot : 'button';

    return (
      <ComponentSlot
        ref={ref}
        className={buttonVariants({ variant, size, outline, className })}
        {...props}
      >
        {children}
      </ComponentSlot>
    );
  }
);

Button.displayName = 'Button';
